import { render, staticRenderFns } from "./IcoSolicitudRechazada.vue?vue&type=template&id=f3517058&scoped=true"
import script from "./IcoSolicitudRechazada.vue?vue&type=script&lang=ts"
export * from "./IcoSolicitudRechazada.vue?vue&type=script&lang=ts"
import style0 from "./IcoSolicitudRechazada.vue?vue&type=style&index=0&id=f3517058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3517058",
  null
  
)

export default component.exports